module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.userMissions) ? _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.startTime')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "74%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.title')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.userMissions), function(userMission) {
    return _c('user-missions-row', {
      key: userMission.uid,
      attrs: {
        "userMission": userMission
      }
    })
  })), _vm._v(" "), _c('tfoot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userMissions.length >= 10),
      expression: "userMissions.length >= 10"
    }]
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.startTime')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "74%"
    }
  }, [_vm._v(_vm._s(_vm.$t('mission.title')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.$t('misc.actions')))])])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a4637c1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/UserMissionsTable.vue
// module id = 478
// module chunks = 0